import React, {memo} from 'react';
import { Box, Button } from "@material-ui/core";
import MaterialTable from "material-table";
import TableIcons from "../../utils/TableIcons";

const ConfigImportTable = memo(({ arr, setImports }) => (
    <Box
        style={{padding: '1px 8px 0', height: '300px', overflowY: 'scroll', overflowX: 'hidden', display: 'flex'}}
    >
        <MaterialTable
            style={{ boxShadow: 'none'}}
            icons={TableIcons}
            columns={[
                {
                    title: 'Id', field: "id", hidden: true
                },
                {
                    title: "Traffic Source Name", field: "name",
                },
                {
                    title: "Affilate Name", field: "affiliate",
                },
                {
                    title: "Min Price", field: "minPrice",
                }]}
            data={
                arr.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        affiliate: item.affiliate.name,
                        minPrice: item.minimumPrice
                    };
                })
            }
            options={{
                selection: true,
                search: false,
                pageSize: 50,
                pageSizeOptions: [50, 100, 150],
                headerStyle: {
                    minWidth: 'auto',
                },
                showTitle: false
            }}
            actions={[
                {
                    tooltip: 'Import Selected',
                    icon: 'delete',
                    onClick: (evt, data) => setImports(data)
                }
            ]}
            components={{
                Action: props => {
                    if(props.action.icon === 'delete') {
                        return (
                            <Button
                                onClick={(event) => props.action.onClick(event, props.data)}
                                color="primary"
                                variant="contained"
                                size="small"
                            >
                                Import {props.data.length} Traffic Sources
                            </Button>
                        );
                    }
                    return "default button";
                },
            }}
        />
    </Box>
));

export default ConfigImportTable;
